export const EXPEDITION_RIGHT_MENU = {
    SET_STATE_MENU: 'EXPEDITION_RIGHT_MENU.SET_STATE_MENU',
    SET_INITIAL_DATE: 'EXPEDITION_RIGHT_MENU.SET_INITIAL_DATE',
    SET_FINAL_DATE: 'EXPEDITION_RIGHT_MENU.SET_FINAL_DATE',
    SET_SITUATIONS: 'EXPEDITION_RIGHT_MENU.SET_SITUATIONS',
    SET_ORDENATE_FILTER: 'EXPEDITION_RIGHT_MENU.SET_ORDENATE_FILTER',
    SET_ID_MENU_SELECTION: 'EXPEDITION_RIGHT_MENU.SET_ID_MENU_SELECTION'
}